import { useState } from 'react'
import useDidUpdate from '../useDidUpdate'
import useDebounce from '../useDebounce'

const useDebounceValue = <T>(input: T, wait: number): T => {
  const [value, setValue] = useState<T>(input)

  const setValueDebounced = useDebounce(setValue, wait)

  useDidUpdate(() => {
    setValueDebounced(input)
  }, [input])

  return value
}

export default useDebounceValue
